import { Service } from '../mainService'

const exportarPcaService = {
    getAnos,
    listarPrestacoes,
    enviarUmaPrestacao
}

async function getAnos() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/exportacao/anos");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function listarPrestacoes(ano) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/exportacao/prestacoes/" + ano);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function enviarUmaPrestacao(pca) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_ENTREGAS_API + "/exportacao/enviarpca/" + pca.IdPrestacaoConta);
        return response;
    } catch (e) {
        return e.response;
    }
}


export default exportarPcaService;